import React, { useEffect, useState } from "react";
import { memberMe, hasMemberToken } from "../../lib/member";

export const pInput = "w-full rounded-xl border border-slate-300 bg-white px-3.5 py-2.5 text-sm outline-none focus:border-[var(--p-teal)] focus:ring-2 focus:ring-[var(--p-teal)]/15";

export function useEntrant() {
  const [f, setF] = useState({ name: "", email: "", phone: "", zip: "", answers: {}, opt_in_news: true, opt_in_sponsor: false });
  const [member, setMember] = useState(null);
  useEffect(() => {
    if (hasMemberToken()) memberMe().then((m) => { setMember(m); setF((x) => ({ ...x, name: m.name, email: m.email, phone: m.phone || "" })); }).catch(() => {});
  }, []);
  return [f, setF, member];
}

export default function EntryFields({ c, f, setF, member }) {
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const setAns = (id, v) => setF({ ...f, answers: { ...f.answers, [id]: v } });
  return (
    <div className="space-y-3" data-testid="entry-fields">
      {member && <p data-testid="entry-member-note" className="rounded-xl bg-[var(--p-teal)]/10 px-3 py-2 text-xs font-semibold text-[var(--p-teal)]">Entering as Loyalty Club member {member.member_no}</p>}
      <div className="grid gap-3 sm:grid-cols-2">
        <input data-testid="entry-name" placeholder="Full name" value={f.name} onChange={set("name")} className={pInput} />
        <input data-testid="entry-email" type="email" placeholder="Email" value={f.email} onChange={set("email")} className={pInput} />
        <input data-testid="entry-phone" placeholder="Mobile (optional)" value={f.phone} onChange={set("phone")} className={pInput} />
        <input data-testid="entry-zip" placeholder="ZIP code" value={f.zip} onChange={set("zip")} className={pInput} />
      </div>
      {(c.lead_questions || []).map((q) => (
        <div key={q.id}>
          <p className="mb-1 text-sm font-semibold text-[var(--p-ink)]">{q.label}{q.required && " *"}</p>
          {q.kind === "choice" ? (
            <div className="flex flex-wrap gap-2">
              {q.options.map((o) => (
                <button type="button" key={o} onClick={() => setAns(q.id, o)} data-testid={`lead-${q.id}-${o}`}
                  className={`rounded-full px-3 py-1.5 text-xs font-semibold ring-1 ${f.answers[q.id] === o ? "bg-[var(--p-teal)] text-white ring-[var(--p-teal)]" : "bg-white text-slate-600 ring-slate-300"}`}>{o}</button>
              ))}
            </div>
          ) : <input data-testid={`lead-${q.id}`} value={f.answers[q.id] || ""} onChange={(e) => setAns(q.id, e.target.value)} className={pInput} />}
        </div>
      ))}
      <label className="flex items-start gap-2 text-xs text-slate-600"><input type="checkbox" data-testid="entry-optin-news" checked={f.opt_in_news} onChange={() => setF({ ...f, opt_in_news: !f.opt_in_news })} className="mt-0.5 accent-[var(--p-teal)]" /> Send me Nassau Life news and contest updates</label>
      {c.sponsor_name && <label className="flex items-start gap-2 text-xs text-slate-600"><input type="checkbox" data-testid="entry-optin-sponsor" checked={f.opt_in_sponsor} onChange={() => setF({ ...f, opt_in_sponsor: !f.opt_in_sponsor })} className="mt-0.5 accent-[var(--p-teal)]" /> Yes, {c.sponsor_name} may send me special offers</label>}
    </div>
  );
}

export function ThankYou({ res, onAgain }) {
  return (
    <div data-testid="entry-thank-you" className="rounded-2xl bg-white p-6 text-center ring-1 ring-slate-200">
      <p className="font-portal text-2xl font-black text-[var(--p-ink)]">{res.message}</p>
      {res.coupon && (
        <div className="mx-auto mt-4 max-w-md rounded-2xl border-2 border-dashed border-[var(--p-amber)] bg-amber-50 p-4">
          <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-[var(--p-clay)]">A thank-you from {res.sponsor_name}</p>
          <p className="mt-1 font-semibold text-[var(--p-ink)]" data-testid="entry-coupon">{res.coupon}</p>
        </div>
      )}
      {onAgain && <button onClick={onAgain} className="mt-4 text-sm font-semibold text-[var(--p-teal)] hover:underline">Back</button>}
    </div>
  );
}
